import AccountCircle from "@mui/icons-material/AccountCircle";
import Chat from "@mui/icons-material/Chat";
import CurrencyExchange from "@mui/icons-material/CurrencyExchange";
import Dashboard from "@mui/icons-material/Dashboard";
import Gavel from "@mui/icons-material/Gavel";
import Mail from "@mui/icons-material/Mail";
import Newspaper from "@mui/icons-material/Newspaper";
import PriorityHigh from "@mui/icons-material/PriorityHigh";
import Subtitles from "@mui/icons-material/Subtitles";
import { useTranslation } from "react-i18next";
import classes from "./Navigation.module.css";
import { NavigationButton } from "./NavigationButton";

interface NavigationProps {}

export const Navigation = (props: NavigationProps) => {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <NavigationButton
        href="/accounts"
        icon={<AccountCircle />}
        text={String(t("Navigation.accounts"))}
      />
      <NavigationButton
        href="/anticheat"
        icon={<Gavel />}
        text={String(t("Navigation.anticheat"))}
      />
      <NavigationButton
        href="/chats"
        icon={<Chat />}
        text={String(t("Navigation.chats"))}
      />
      <NavigationButton
        href="/dashboard"
        icon={<Dashboard />}
        text={String(t("Navigation.dashboard"))}
      />
      <NavigationButton
        href="/mails"
        icon={<Mail />}
        text={String(t("Navigation.mails"))}
      />
      <NavigationButton
        href="/news-events"
        icon={<Newspaper />}
        text={String(t("Navigation.newsEvents"))}
      />
      <NavigationButton
        href="/reports"
        icon={<PriorityHigh />}
        text={String(t("Navigation.reports"))}
      />
      <NavigationButton
        href="/scratchcodes"
        icon={<Subtitles />}
        text={String(t("Navigation.scratchcodes"))}
      />
      <NavigationButton
        href="/transactions"
        icon={<CurrencyExchange />}
        text={String(t("Navigation.transactions"))}
      />
    </div>
  );
};
